import { Environment } from "./environment.interface";

export const environment: Environment = {
  production: false,
  title: 'AdvERP',
  // apiURL: 'https://dev.apig.vnccy.com',
  AMBaseURL: 'https://dev.apig.am.vnccy.com',
  // Fixed - never overridden per tenant. Only the 28 microservices tied to
  // the synced identity tables (see 2026-07-24_TenantIdentitySync_Triggers.sql)
  // + ServerPool build their URLs from this constant. Everything else under
  // AM (DocumentMaster, PrintTemplate, etc.) keeps using AMBaseURL above,
  // which the ApiUrlRewriteInterceptor can still override per tenant.
  AIBaseURL: 'https://dev.apig.ai.vnccy.com',
  BIRBaseURL: 'https://dev.apig.bir.vnccy.com',
  CRMBaseURL: 'https://dev.apig.crm.vnccy.com',
  DOBaseURL: 'https://dev.apig.do.vnccy.com',
  ERPBaseURL: 'https://dev.apig.erp.vnccy.com',
  EXTBaseURL: 'https://dev.apig.ext.vnccy.com',
  HRMSBaseURL: 'https://dev.apig.hrms.vnccy.com',
  NTBaseURL: 'https://dev.apig.nt.vnccy.com',
  PMSBaseURL: 'https://dev.apig.pms.vnccy.com',
  PRBaseURL: 'https://dev.apig.pr.vnccy.com',
  SPDBaseURL: 'https://dev.apig.spd.vnccy.com',
  appClientId: "AdvERP20250603",
  CompanyId: "1",
  BranchId: "1",
  SoftwareId: "1",
  MetaAppId: "1146473447335601",
  redirectBaseURL: 'http://localhost:4200',
  supportProviderTenantId: 1,
  supportProviderTenantBranchId: 1,
  // Local static servers (unlike prod IIS's web.config rewrite) don't
  // resolve the extension-less /support route, so dev points at the file
  // directly.
  ticketSupportSiteUrl: 'http://127.0.0.1:5500/support.html',
  ValueListAPI: 'https://dev.apig.am.vnccy.com/AM/VL/ReadFilteredKeyValueExtendedByCode',
  APIConfig: 'https://dev.apig.am.vnccy.com/AM/SP/GetApiConfiguration/',

  // Firebase project: advinerp-dev (dev/test)
  firebase: {
    apiKey: 'AIzaSyBQ9peMrKIYr60I3Th_HQLQjUM7AXbjkk4',
    authDomain: 'advinerp-dev.firebaseapp.com',
    projectId: 'advinerp-dev',
    storageBucket: 'advinerp-dev.firebasestorage.app',
    messagingSenderId: '936992159782',
    appId: '1:936992159782:web:dbd528a82fa77478b68ee7',
  },
  firebaseVapidKey: 'BGVmUYsJXMI54FnMW0OLI0l_l0RNJ6fjeZy0xVuUwyB9mF1OvQNSneAK8wtBhT42o2Uo5vZ_yPQsCTbVv-6Js1w',

  firebaseJs : 'firebase-messaging-sw.js',

  getApiUrl: function (path: string): string {
    if (!path || !path.startsWith('/')) {
      return path;
    }

    const segments = path.split('/').filter(s => s.length > 0);
    if (segments.length === 0) {
      return path;
    }

    const prefix = segments[0].toUpperCase();
    const baseUrlKey = `${prefix}BaseURL` as keyof typeof environment;

    if (this[baseUrlKey] && typeof this[baseUrlKey] === 'string') {
      return this[baseUrlKey] + path;
    }

    return path;
  }
};